import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function SaleSupport (){
  const {user} = useUser()
  let view = contentLayout[modules.BillList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.BillList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.BillList}></Index>
 )
}

export default SaleSupport